import React, { useState } from 'react';

import { ACTION_CREATE } from 'constants/permission.constants';
import { AddIcon } from 'constants/icon.constants';
import { DataTableAction } from 'components/DataTable';
import { ENTITY_USER } from 'constants/schemas';
import NewUserDialog from './NewUserDialog';
import { formatType } from 'utils/entity.utils';
import { useMyGlobalPermission } from 'hooks/store.hooks';

function ActionAddUser() {
  const [newUserDialogOpen, setNewUserDialogOpen] = useState(false);
  const canCreateUser = useMyGlobalPermission(ENTITY_USER, ACTION_CREATE);
  return !canCreateUser ? null : (
    <DataTableAction
      label={`Add ${formatType(ENTITY_USER)}`}
      icon={<AddIcon />}
      onClick={() => setNewUserDialogOpen(true)}
    >
      <NewUserDialog
        open={newUserDialogOpen}
        onClose={() => setNewUserDialogOpen(false)}
      />
    </DataTableAction>
  );
}

export default ActionAddUser;
